import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import { useAuth } from './AuthContext';
import Navbar from './components/Navbar';
import Footer from './components/Footer';
import ScrollToTop from './components/ScrollToTop';
import HomePage from './pages/HomePage';
import AboutPage from './pages/AboutPage';
import CoachingPage from './pages/CoachingPage';
import EventsPage from './pages/EventsPage';
import TestsPage from './pages/TestsPage';
import LoginPage from './pages/LoginPage';
import PricingPage from './pages/PricingPage';
import PaymentSuccessPage from './pages/PaymentSuccessPage';
import ProfilePage from './pages/ProfilePage';
import PsychologistDashboard from './pages/PsychologistDashboard';
import BookingSuccess from './pages/BookingSuccess';
import BookingCancelled from './pages/BookingCancelled';
import './App.css';


const ProtectedRoute = ({ children }) => {
    const { currentUser, loading } = useAuth();
    if (loading) return <div className="flex justify-center items-center h-screen">Se încarcă...</div>;
    return currentUser ? children : <Navigate to="/login" />;
};

function App() {
    return (
        <Router>
            <ScrollToTop />
            <div className="App">
                <Navbar />
                <Routes>
                    <Route path="/" element={<HomePage />} />
                    <Route path="/despre" element={<AboutPage />} />
                    <Route path="/pricing" element={<PricingPage />} />
                    <Route path="/payment-success" element={<PaymentSuccessPage />} />
                    <Route path="/coaching" element={<CoachingPage />} />
                    <Route path="/evenimente" element={<EventsPage />} />
                    <Route path="/login" element={<LoginPage />} />
                    <Route path="/booking-success" element={<BookingSuccess />} />
                    <Route path="/booking-cancelled" element={<BookingCancelled />} />
                    <Route
                        path="/teste"
                        element={
                            <ProtectedRoute>
                                <TestsPage />
                            </ProtectedRoute>
                        }
                    />
                    <Route
                        path="/profile"
                        element={
                            <ProtectedRoute>
                                <ProfilePage />
                            </ProtectedRoute>
                        }
                    />
                    <Route path="/psiholog-dashboard" element={
                        <ProtectedRoute requiredRole="psychologist">
                            <PsychologistDashboard />
                        </ProtectedRoute>
                    } />
                </Routes>
                <Footer />
            </div>
        </Router>
    );
}

export default App;